import { render, staticRenderFns } from "./TabStaffRoster.vue?vue&type=template&id=a875b5ee"
import script from "./TabStaffRoster.vue?vue&type=script&lang=js"
export * from "./TabStaffRoster.vue?vue&type=script&lang=js"
import style0 from "./TabStaffRoster.vue?vue&type=style&index=0&id=a875b5ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports